import React from 'react';
import './Amenities.css';
import bedImg from '../../assets/Bed.png';
import bathImg from '../../assets/Bath.png';
import parkImg from '../../assets/parking.png';

const AmenityCard = ({ img, label, sub }) => (
  <div className="amenity-box">
    <img src={img} alt={label} className="amenity-img" />
    <div className="amenity-text">
      <h3>{label}</h3>
      <p>{sub}</p>
    </div>
  </div>
);

const Amenities = () => {
  return (
    <div className="amenities-wrapper">
      <AmenityCard img={bedImg} label="4 Bedrooms" sub="Spacious and comfortable" />
      <AmenityCard img={bathImg} label="2 Bathrooms" sub="Modern fixtures" />
      <AmenityCard img={parkImg} label="2 Parking Spaces" sub="Covered garage" />
    </div>
  );
};

export default Amenities;